import React from "react";
import { translateText } from "../../../../../Helper_functions";

const OtherMetrics = (props) => {
  return (
    <div className="main-content security-settings app-settings-form">
      <div className="user-management-form">
        <section className="form-header">
          <h1>{translateText("other_metrics", props.LangData)}</h1>
        </section>
        <section className="form-body single-field-form">
          {translateText("no_other_metrics_available", props.LangData)}.
        </section>
      </div>
    </div>
  );
};

export default OtherMetrics;
